<app-page-body>
  <!-- header -->
  <app-page-header
    [title]="title"
    [isForm]="true"
    [loading]="loading"
    (onBack)="onClose()"
    (onRefresh)="onReset()"
  >
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <section class="tw-mt-5">
        <fieldset>
          <legend>
            {{ pageVocabs + "legend" | translate }}
          </legend>
          <!--index-->
          <div class="sm:tw-w-1/2 xl:tw-w-1/3 2xl:tw-w-1/4">
            <enum-select-search
              enumName="UserValueOfPurchaseIndex"
              [control]="form?.get('index')"
              [label]="fields + 'index'"
              [(value)]="model.index"
              (onError)="onClose()"
            >
            </enum-select-search>
          </div>
          <div class="tw-flex-center tw-flex-col">
            <div
              class="tw-flex tw-justify-center flex-column tw-py-[5px] tw-px-[5px]"
            >
              <!-- editable -->
              <div class="editable-table">
                <ng-content select="[BeforeContent]"></ng-content>

                <!-- cols -->
                <div class="cols">
                  <!-- empty col -->
                  <div
                    class="col__item tw-flex-center tw-font-medium tw-text-[13px]"
                    style="width: 210px"
                  >
                    {{ fields + "range" | translate }}
                  </div>

                  <ng-container *ngFor="let item of [1]; let index = index">
                    <ng-container>
                      <div class="col__item">
                        <!-- title -->
                        <div class="col__title dark:tw-text-gray-200">
                          {{ fields + "point" | translate }}
                        </div>

                        <!-- inputs -->
                        <div class="col__inputs">
                          <div class="col__input">
                            <input
                              type="number"
                              #scoreInput
                              min="0"
                              [onlyNumbers]="true"
                              (keydown)="fillColumn(scoreInput, $event)"
                              step="50"
                              class="dir-ltr"
                              class="input-group"
                            />

                            <i
                              class="fas fa-arrow-down text-navyBlue"
                              (click)="fillColumn(scoreInput)"
                            ></i>
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </ng-container>
                </div>

                <!-- rows -->
                <div class="rows">
                  <ng-container
                    *ngFor="let range of sizeRanges; let rangeIndex = index"
                  >
                    <div class="row__flex">
                      <!-- SmsCpValues names -->
                      <div class="row__title tw-px-1 tw-relative">
                        <!-- valueStartRange -->
                        <span class="tw-mx-[5px]">{{
                          "common.from" | translate
                        }}</span>
                        <input
                          #beginningInput
                          class="dark:tw-bg-dark-500 size-input"
                          [value]="
                            range?.valueStartRange ||
                            range?.valueStartRange == 0
                              ? range?.valueStartRange
                              : ''
                          "
                          (input)="
                            onUpdateSizeRange(
                              beginningInput,
                              endInput,
                              rangeIndex
                            )
                          "
                        />

                        <!-- valueEndRange -->
                        <span class="tw-mx-[5px]">{{
                          "common.to" | translate
                        }}</span>
                        <input
                          #endInput
                          class="dark:tw-bg-dark-500 size-input"
                          [value]="
                            range?.valueEndRange == -1
                              ? '∞'
                              : range?.valueEndRange ||
                                range?.valueEndRange == 0
                              ? range?.valueEndRange
                              : ''
                          "
                          (input)="
                            onUpdateSizeRange(
                              beginningInput,
                              endInput,
                              rangeIndex
                            )
                          "
                        />

                        <!-- infinity btn  -->
                        <div
                          *ngIf="
                            rangeIndex == sizeRanges.length - 1 &&
                            !range?.valueEndRange
                          "
                          class="bg-bright-primary tw-cursor-pointer dark:tw-bg-primary-600 tw-text-[#283891] hover:tw-bg-blue-700 tw-flex justify-center tw-px-1 items-center tw-absolute tw-h-[18px] tw-left-[18px] tw-rounded-[5px]"
                          (click)="
                            setInfinite(beginningInput, endInput, rangeIndex)
                          "
                        >
                          ∞
                        </div>

                        <!-- add btn  -->
                        <!-- <i *ngIf="rangeIndex==sizeRanges?.length-1" (click)="onAddSizeRange()"
                          class="tw-absolute lg:tw-right-[-35px] tw-right-[-19px] mdi mdi-24px
                                                        tw-bg-white tw-rounded-full dark:tw-bg-dark-500 mdi-plus-circle text-success tw-mx-1 tw-cursor-pointer"></i> -->

                        <!-- remove btn  -->
                        <i
                          *ngIf="
                            rangeIndex != sizeRanges?.length &&
                            sizeRanges?.length > 1
                          "
                          (click)="onRemoveSizeRange(rangeIndex)"
                          class="tw-absolute lg:tw-right-[-35px] tw-right-[-19px] mdi mdi-24px tw-bg-white tw-rounded-full dark:tw-bg-dark-500 mdi-close-circle-outline text-danger tw-mx-1 tw-cursor-pointer"
                        ></i>
                      </div>

                      <!-- input values -->
                      <ng-container *ngFor="let priceItem of [1]">
                        <ng-container>
                          <div class="row__value">
                            <input
                              #priceInput
                              type="number"
                              class="input-item dir-ltr"
                              min="0"
                              step="1000"
                              (focus)="isEmptyInput($event)"
                              (change)="isEmptyInput($event)"
                              [attr.data-point]="range?.point"
                              [attr.data-valueStartRange]="
                                range?.valueStartRange
                              "
                              [attr.data-valueEndRange]="range?.valueEndRange"
                              [value]="range.point"
                              placeholder="-"
                            />
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="tw-mt-[10px]">
                <a
                  class="btn tw-mx-2"
                  class="btn btn-light-success tw-w-[210px]"
                  (click)="onAddSizeRange()"
                >
                  <span>{{ "common.addRow" | translate }}</span>
                  <i class="mdi mdi-plus-circle tw-text-xl"></i>
                </a>
              </div>
            </div>
          </div>
        </fieldset>
      </section>

      <!-- form btns-->
      <app-form-btns
        [loading]="loading"
        [form]="form"
        [isEdit]="formPageConfig.isEditMode"
        (onClose)="onClose()"
        (onSubmit)="onSubmit()"
      >
      </app-form-btns>
    </form>
  </div>
</app-page-body>
